import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import { ModalButtonSave, ModalButtonUpdate, } from '../../constant';
import { FormMicReturnReasons } from './FormMicReturnReasons';
import { DeleteMicReturnReasons } from './DeleteMicReturnReasons';
import { Dialog } from 'primereact/dialog';

export const ModalMicReturnReasons = (props) => {

    const {
        modal, modalTitle, toggle, method, loading,
        return_reason, handleInputChange,
        validaciones, saveCreate, saveUpdate, saveDelete,
        closeDialog
    } = props;

    return (
        <Dialog header={modalTitle} visible={modal} onHide={closeDialog} closable={true} modal blockScroll className='medium-dialog'>
        
            {
                method === "create"
                    ?
                    <FormMicReturnReasons
                        button={ModalButtonSave}
                        {...{ closeDialog, loading, handleInputChange, methodAction: saveCreate }}
                    />
                    :
                    (method === "update")
                        ?
                        <FormMicReturnReasons
                            button={ModalButtonUpdate}
                            {...{ closeDialog, loading, handleInputChange, validaciones, methodAction: saveUpdate, return_reason, }}
                        />
                        :
                        null
            }
        </Dialog>
    )
}
